import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import SingleFeeder from './components/Single';
import * as serviceWorker from './serviceWorker';

const element = document.getElementById('multi-feed-component') as HTMLElement;
const singleElement = document.getElementById('blog-feed-component') as HTMLElement;

if (element !== null ) {
     const data: string = (element !== null )? element.getAttribute('data') || '': '';
     ReactDOM.render( <App data={data} />, element);     
}

if(singleElement !== null){
     ReactDOM.render(<SingleFeeder element={singleElement} />, singleElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls. Learn
// more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
